import React from 'react';
// import styled from 'styled-components';
import { DiagramView, parseLoads } from './taskListElements/diagramView';
import cloneDeep from 'lodash/cloneDeep';
import { TaskListView } from './taskListElements/listView';


export const TaskList = ({tasks, truckId, currentData, setDataMethod, showTooltip}) =>{
    const _setTasks = (tasks, response) => {
        const newData = cloneDeep(currentData);
        newData.tasks = tasks.length === 0 ? null : tasks;
        if(response){
            if(response.thisWeeksLoads){
                newData.thisWeeksLoads = parseLoads(response.thisWeeksLoads);
            }
            if('currentTrailer' in response ){
                newData.currentTrailer = response.currentTrailer;
            }
        }
        setDataMethod(newData);
    }
    return <div>
        <DiagramView taskList={tasks} setTasks={_setTasks} truckId={truckId} showTooltip={showTooltip} />
        
        <TaskListView tasks={tasks} />
    </div>
}
